import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'bloko/blocks/radio/radio.less';

const Radio = (props) => {
    const { children, invalid, innerRef, labelProps, wrapperProps, ...radioProps } = props;

    return (
        <label
            className={classnames('bloko-radio', {
                'bloko-radio_invalid': invalid,
            })}
            {...wrapperProps}
            ref={innerRef}
        >
            <input type="radio" className="bloko-radio__input" {...radioProps} />
            <span className="bloko-radio__text" {...labelProps}>
                {children}
            </span>
        </label>
    );
};

Radio.propTypes = {
    /** Содержимое внутри лейбла radio*/
    children: PropTypes.node,
    /** Обработчик onChange, в качестве аргумента передает event */
    onChange: PropTypes.func,
    /** Функция для получения рутового DOM элемента компонента Radio*/
    innerRef: PropTypes.func,
    /** Свойства лейбла radio */
    labelProps: PropTypes.object,
    /** Свойства обертки radio */
    wrapperProps: PropTypes.object,
    /** Флаг checked контрола по умолчанию для uncontrolled radio */
    defaultChecked: PropTypes.bool,
    /** Флаг checked контрола */
    checked: PropTypes.bool,
    /** Значение по умолчанию для uncontrolled */
    defaultValue: PropTypes.string,
    /** Значение по умолчанию */
    value: PropTypes.string,
    /** Флаг disabled контрола */
    disabled: PropTypes.bool,
    /** Флаг не валидности контрола */
    invalid: PropTypes.bool,
};

Radio.defaultProps = {
    disabled: false,
    invalid: false,
};

export default Radio;
